import React, { useState } from 'react';
import { HiX } from 'react-icons/hi';
import { BsMoonStarsFill, BsSunFill } from 'react-icons/bs';
import { RxHamburgerMenu } from 'react-icons/rx';
import { motion } from 'framer-motion';

const NAV_ITEMS = ['About', 'Work', 'Certifications', 'Skills', 'Contact'];

const NavBar = ({ theme, onToggleTheme }) => {
  const [menuToggled, setMenuToggle] = useState(false);

  const toggleMenu = () => {
    setMenuToggle((prev) => !prev);
  };

  return (
    <nav className="site-nav">
      <div className="nav-left">
        <button className="menu-btn" type="button" aria-label="Toggle menu" onClick={toggleMenu}>
          {menuToggled ? <HiX size={18} /> : <RxHamburgerMenu size={18} />}
        </button>
        <a href="#About" className="brand-lockup" aria-label="Go to about section">
          <span className="brand-dot" />
          <div>
            <p className="brand-name">Ryan O. Lee</p>
            <p className="brand-url">ryanolee.dev</p>
          </div>
        </a>
      </div>

      <ul className="desktop-nav">
        {NAV_ITEMS.map((item) => (
          <li key={`desktop-link-${item}`}>
            <a className="nav-link" href={`#${item}`}>
              {item}
            </a>
          </li>
        ))}
      </ul>

      <div className="nav-right">
        <button className="theme-btn" type="button" aria-label="Toggle light and dark mode" onClick={onToggleTheme}>
          {theme === 'dark' ? <BsSunFill size={14} /> : <BsMoonStarsFill size={14} />}
        </button>
        <a className="desktop-cta" href="#Contact">
          Let&apos;s Connect
        </a>
      </div>

      {menuToggled && (
        <motion.div
          className="mobile-menu"
          initial={{ x: -280, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.25, ease: 'easeOut' }}
        >
          {NAV_ITEMS.map((item) => (
            <a key={`mobile-link-${item}`} className="mobile-nav-link" onClick={toggleMenu} href={`#${item}`}>
              {item}
            </a>
          ))}
        </motion.div>
      )}
    </nav>
  );
};

export default NavBar;
